import { snakeCase } from "lodash";

import { Organization } from "@inductiveautomation/ws-components";
import { OrganizationActionType } from "./Organizations.types";

export const testIdForOrganization = (
  organization: Pick<Organization, "orgName">
) => `organization-${snakeCase(organization.orgName)}`;

export const testIdForOrganizationDrawerAction = (
  organization: Pick<Organization, "orgName">,
  type: Exclude<OrganizationActionType, "leave_multiple_organizations">
) => {
  return `organization-${snakeCase(organization.orgName)}-${snakeCase(type)}`;
};
